module.exports = __webpack_public_path__ + "img/mailContact.ccd2e4f1.svg";